const cardBlacklist = {
  header: {
    btnCreate: 'Crear',
  },

  forms: {
    header: {
      create: {
        title: 'Crear',
      },
      update: {
        title: 'Actualizar',
      },
    },
    create: {
      success: '¡Se ha añadido una tarjeta de la blacklist',
      failure: 'No se pudo crear una tarjeta de la blacklist',
      header: 'Crear elemento de la blacklist',
      footer: {
        submit: 'Enviar',
      },
    },
    update: {
      footer: {
        submit: 'Actualizar',
      },
    },
    sections: {
      details: {
        header: 'Detalles',
        fields: {
          number: 'Número de la tarjeta',
        },
      },
    },
  },
  table: {
    headers: {
      number: 'NÚMERO DE CARTA',
      site: 'Sitio',
    },
    actions: {
      delete: {
        modal: {
          header: 'Eliminar blacklist',
          body: 'Está a punto de eliminar {{num}} blacklist',
        },
        success: 'La blacklist se eliminó correctamente',
      },
      create: 'Crear',
    },
    floatingActions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    
  },
};

export default cardBlacklist;
